import { LockIcon } from "./icons/LockIcon";
import "./TrustCard.css";

export function TrustCard() {
  return (
    <aside className="trust-card" aria-labelledby="trust-card-title">
      <span className="trust-card__icon" aria-hidden="true">
        <LockIcon size={64} />
      </span>
      <div className="trust-card__content">
        <p className="trust-card__title" id="trust-card-title">
          SECURE CHECKOUT VIA STRIPE
        </p>
        <p className="trust-card__line">Safe. Encrypted. Trusted.</p>
        <p className="trust-card__line">We never store your card details.</p>
      </div>
      <img
        src="/assets/stripe-wordmark.svg"
        alt="Stripe"
        className="trust-card__brand"
        width="80"
        height="33"
      />
    </aside>
  );
}
